import { Component, OnInit } from "@angular/core";
import { ProjectService } from "../../services/project/project.service";
import { Project } from "../../interfaces/project";
import { ActivatedRoute } from "@angular/router";
import { Router } from "@angular/router";
import { environment } from "../../../environments/environment";
import { ShareResponse } from "../../interfaces/shareResponse";
import { MzToastService } from "ng2-materialize";
import { User } from "../../interfaces/user";
import { MzProgressModule } from "ng2-materialize";
import { FormGroup } from "@angular/forms";
import { SessionService } from "../../services/session/session.service";
import { Observable } from "rxjs";
import { SprintService } from "../../services/sprint/sprint.service";
import { FeatureService } from "../../services/feature/feature.service";
import { Sprint } from "../../interfaces/sprint";

@Component({
  selector: "app-project-dashboard",
  templateUrl: "./project-dashboard.component.html",
  styleUrls: ["./project-dashboard.component.scss"],
})
export class ProjectDashboardComponent implements OnInit {
  sprintNames: string[];
  agreementScores: any[];
  colorScheme = {
    domain: ["#1594A6", "#7bc2ce"],
  };

  env: any = environment;
  project: Project;
  projectClone: Project;
  shareAddresses: string;
  projectId: any;
  projectToDelete: string;
  userToDelete: any;
  estimateLink: string;
  loading: boolean = true;
  emailValidateError: string = "Das E-Mail-Format ist ungültig.";
  emailIsInvalid: boolean = false;
  showAnnotations: Observable<boolean> = this.sessionService
    .getRoles()
    .map((x) => x.indexOf("annotations") >= 0);

  sprints: Sprint[];

  classNameDependentOnIssueTracker() {
    if (this.project.issueTrackerLink.issueTracker === null) {
      return "no-issue-tracker";
    } else {
      return "with-issue-tracker";
    }
  }

  constructor(
    private sessionService: SessionService,
    private sprintService: SprintService,
    private featureService: FeatureService,
    private projectService: ProjectService,
    private toastService: MzToastService,
    private route: ActivatedRoute,
    private router: Router
  ) {}

  ngOnInit() {
    this.route.params.subscribe(async (params: { id: string }) => {
      this.loading = true;
      let project = await this.projectService.getProjectByShortId(params.id);
      this.project = project;
      this.projectId = this.project._id;
      this.estimateLink =
        this.env.agirUrl + "/planning-poker/" + this.project.shortId;
      this.loading = false;

      let sprints = await this.sprintService.getSprintsByProjectId(
        this.project._id
      );
      let features = await this.featureService.getFeaturesByProjectId(
        this.project._id
      );
      sprints.forEach((x) => {
        x["features"] = features.filter((y) => x._id == y.sprint);
      });

      this.sprints = [];
      let runningSprint =
        sprints.filter((x) => x.state === "active").length > 0
          ? sprints.filter((x) => x.state === "active")[0]
          : null;
      if (runningSprint) this.sprints.push(runningSprint);
      let plannedSprints = sprints
        .filter((x) => x.state === "future")
        .sort((x, y) => y.index - x.index);
      [].push.apply(this.sprints, plannedSprints);
      let backlog =
        sprints.filter((x) => x.state === "backlog").length > 0
          ? sprints.filter((x) => x.state === "backlog")[0]
          : null;
      if (backlog) this.sprints.push(backlog);
      let closedSprints = sprints
        .filter((x) => x.state === "closed")
        .sort(
          (x, y) =>
            new Date(y.completeDate).getTime() -
            new Date(x.completeDate).getTime()
        );
      [].push.apply(this.sprints, closedSprints);
    });
  }

  percentTickFormatting(val: number): string {
    return val.toLocaleString() + " %";
  }

  /**
   * Switches between the infos and the form and updates the metaInfos if nessesary
   */
  update(project) {
    this.projectClone = this.project;
    this.projectService
      .updateProject(project)
      .then(() => {
        // this.toastService.show('Gespeichert!', 4000, 'confirm-toast');
      })
      .catch((res) => {
        console.log(res);
        this.project = this.projectClone;
        this.toastService.show(
          "Fehler! Nicht Gespeichert",
          4000,
          "notification-toast"
        );
      });
  }

  shareProject() {
    if (this.shareAddresses) {
      this.emailIsInvalid = false;
      this.loading = true;
      this.projectService
        .shareProject(this.projectId, this.shareAddresses)
        .then((response: ShareResponse) => {
          this.loading = false;
          response.results.forEach((x) => {
            switch (x.result) {
              case "user_is_owner":
                this.toastService.show(
                  "Du bist bereits Projektteilnehmer.",
                  4000,
                  "notification-toast"
                );
                break;

              case "user_already_added":
                this.toastService.show(
                  x.name + " ist bereits Projektteilnehmer.",
                  4000,
                  "notification-toast"
                );
                break;

              case "error_adding_user":
                this.toastService.show(
                  x.name + " konnte dem Projekt nicht hinzugefügt werden.",
                  4000,
                  "notification-toast"
                );
                break;

              case "user_added_but_sendmail_failed":
                this.toastService.show(
                  x.name +
                    " wurde dem Projekt hinzugefügt, Benachrichtigung wurde nicht verschickt.",
                  4000,
                  "notification-toast"
                );
                break;

              case "user_added":
                this.toastService.show(
                  x.name + " wurde eingeladen!",
                  4000,
                  "confirm-toast"
                );
                break;

              case "user_already_invited":
                this.toastService.show(
                  x.email + " wurde bereits eingeladen.",
                  4000,
                  "notification-toast"
                );
                break;

              case "error_creating_invitation":
                this.toastService.show(
                  x.email + " konnte nicht eingeladen werden.",
                  4000,
                  "notification-toast"
                );
                break;

              case "invitation_created_but_sendmail_failed":
                this.toastService.show(
                  x.email +
                    " wurde eingeladen, aber es konnte keine Benachrichtigung verschickt werden.",
                  4000,
                  "notification-toast"
                );
                break;

              case "user_invited":
                this.toastService.show(
                  x.email + " wurde eingeladen!",
                  4000,
                  "confirm-toast"
                );
                break;
            }
          });
          this.shareAddresses = undefined;
          this.projectService
            .getProjectByShortId(this.project.shortId)
            .then((project: Project) => {
              this.project = project;
            });
        })
        .catch((error) => {
          this.toastService.show(
            this.shareAddresses +
              " konnte dem Projekt nicht hinzugefügt werden.",
            4000,
            "notification-toast"
          );
          this.emailIsInvalid = true;
          this.loading = false;
        });
    }
  }

  deleteProjectById(modal, $event) {
    $event.stopPropagation();
    if (!this.project.userIsOwner) return;
    modal.open();
  }

  deleteProject() {
    this.projectToDelete = undefined;
    this.loading = true;
    this.projectService.deleteProjectById(this.project._id).then(() => {
      this.loading = false;
      this.toastService.show("Projekt gelöscht!", 4000, "notification-toast");
      this.router.navigate(["projects"]);
    });
  }

  removeUserPrompt(modal, user, $event) {
    $event.stopPropagation();
    if (!this.project.userIsOwner) return;
    this.userToDelete = user;
    modal.open();
  }

  removeInvitation() {
    if (this.userToDelete) {
      this.loading = true;
      this.projectService
        .removeInvitation(this.project._id, this.userToDelete)
        .then(() => {
          this.projectService
            .getProjectByShortId(this.project.shortId)
            .then((project: Project) => {
              this.loading = false;
              this.project = project;
              this.toastService.show(
                this.userToDelete + " wurde aus dem Projekt entfernt!",
                4000,
                "notification-toast"
              );
            });
        });
    }
  }

  removeUser() {
    if (this.userToDelete) {
      this.loading = true;
      let userID = this.userToDelete._id;

      this.projectService
        .removeUserFromProject(this.project._id, userID)
        .then(() => {
          this.projectService
            .getProjectByShortId(this.project.shortId)
            .then((project: Project) => {
              this.loading = false;
              this.project = project;
              this.toastService.show(
                this.userToDelete.name + " wurde aus dem Projekt entfernt!",
                4000,
                "notification-toast"
              );
              // this.userToDelete = undefined;
            });
        });
    }
  }

  /**
   * toast for copy estimate-link to clipboard
   */
  toastCopyToClipboard() {
    this.toastService.show(
      "Link wurde in die Zwischenablage kopiert!",
      4000,
      "confirm-toast"
    );
  }

  /**
   * set estimate-password value and if its required
   */
  setEstimatePassword() {
    this.projectService
      .setEstimatePassword(this.project)
      .then(() => {
        // Materialize.toast('Gespeichert!', 3000);
        this.toastService.show("Passwort gespeichert!", 4000, "confirm-toast");
      })
      .catch((res) => {
        // Materialize.toast('Fehler! Nicht Gespeichert', 3000);
        this.toastService.show(
          "Fehler! Nicht gespeichert",
          4000,
          "notification-toast"
        );
      });
  }

  /**
   * get the agreement average of the project and returns it in percent for the slider
   * @returns {number}
   */

  // getProjectAgreementAverage() {
  //   if (!this.project.agreement.average && this.project.agreement.average !== 0) {
  //     return '-';
  //   }
  //   else if (this.project.agreement.average <= 0) {
  //     return ((-this.project.agreement.average) * 100).toFixed(1);
  //   }
  //   else {
  //     return (this.project.agreement.average * 100).toFixed(1);
  //   }
  // }

  // /**
  //  * get the agreement median of the project and returns it in percent for the slider
  //  * @returns {number}
  //  */
  // getProjectAgreementMedian() {
  //   if (!this.project.agreement.median && this.project.agreement.median !== 0) {
  //     return '-';
  //   }
  //   else if (this.project.agreement.median <= 0) {
  //     return ((-this.project.agreement.median) * 100).toFixed(1);
  //   }
  //   else {
  //     return (this.project.agreement.median * 100).toFixed(1);
  //   }
  // }

  calcAverage(values: number[]): number {
    if (values.length === 0) return null;

    var sum = values.reduce(function (a, b) {
      return a + b;
    });
    return sum / values.length;
  }

  calcMedian(values: number[]): number {
    if (values.length === 0) return null;

    values.sort(function (a, b) {
      return a - b;
    });

    var half = Math.floor(values.length / 2);

    if (values.length % 2) return values[half];
    else return (values[half - 1] + values[half]) / 2.0;
  }

  getSprintAverage(sprint: Sprint) {
    let values = [].concat
      .apply(
        [],
        sprint["features"]
          .filter(
            (x) =>
              x.estimations &&
              x.estimations.length > 0 &&
              x.estimations[0].participants &&
              x.estimations[0].participants.length > 0
          )
          .map((x) => x.estimations[0].participants)
      )
      .filter(
        (x) =>
          (x.estimation || x.estimation === 0) &&
          x.estimation !== "pause" &&
          x.estimation !== "?"
      )
      .map((x) => Number(x.estimation));
    let value = this.calcAverage(values);

    if (!value && value !== 0) {
      return "-";
    } else if (value <= 0) {
      return Number(-value).toFixed(1);
    } else {
      return Number(value).toFixed(1);
    }
  }

  getSprintMedian(sprint: Sprint) {
    let values = [].concat
      .apply(
        [],
        sprint["features"]
          .filter(
            (x) =>
              x.estimations &&
              x.estimations.length > 0 &&
              x.estimations[0].participants &&
              x.estimations[0].participants.length > 0
          )
          .map((x) => x.estimations[0].participants)
      )
      .filter(
        (x) =>
          (x.estimation || x.estimation === 0) &&
          x.estimation !== "pause" &&
          x.estimation !== "?"
      )
      .map((x) => Number(x.estimation));
    let value = this.calcMedian(values);

    if (!value && value !== 0) {
      return "-";
    } else if (value <= 0) {
      return Number(-value).toFixed(1);
    } else {
      return Number(value).toFixed(1);
    }
  }

  getProjectBenefitAgreementAverage() {
    if (
      !this.project.benefitagreement.average &&
      this.project.benefitagreement.average !== 0
    ) {
      return "-";
    } else if (this.project.benefitagreement.average <= 0) {
      return (-this.project.benefitagreement.average).toFixed(1);
    } else {
      return this.project.benefitagreement.average.toFixed(1);
    }
  }

  /**
   * get the agreement median of the project and returns it in percent for the slider
   * @returns {number}
   */
  getProjectBenefitAgreementMedian() {
    if (
      !this.project.benefitagreement.median &&
      this.project.benefitagreement.median !== 0
    ) {
      return "-";
    } else if (this.project.benefitagreement.median <= 0) {
      return (-this.project.benefitagreement.median).toFixed(1);
    } else {
      return this.project.benefitagreement.median.toFixed(1);
    }
  }
}



// WEBPACK FOOTER //
// /agir/src/app/components/project-dashboard/project-dashboard.component.ts